import webApi from './api'

export class VehicleInfoService {
  async getInfo (params) {
    return webApi.get('/car-detail/redbook-october', {
      params
    });
  }
  getInfoByRego (regoNumber, state) {
    return webApi.post('/car-detail/rego-search', { regoNumber, state });
  }
}

const vehicleInfoService = new VehicleInfoService()

export default vehicleInfoService
